import { HYDRATE_STATE } from '../../../integrations/hydration'

/**
 * @typedef {boolean} LegacyLinkState Whether the page URL originally had legacy params
 */

/**
 * @param {LegacyLinkState} initialState
 * @returns {(state: LegacyLinkState, action: Object) => LegacyLinkState}
 */
export default function LegacyLinkReducer(initialState) {
    return (state = initialState, action) => {
        if (action.type === HYDRATE_STATE && action.state.isLegacyLink) {
            return action.state.isLegacyLink
        }
        return state
    }
}
